import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import ArticleCards from "./components/ArticleCards";
import ValueProposition from "./components/ValueProposition";
import FeaturesSection from "./components/FeaturesSection";
import TrustSection from "./components/TrustSection";
import SafetySection from "./components/SafetySection";
import FinalCta from "./components/FinalCta";

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL;

  return (
    <div className="min-h-screen bg-background-50">
      {/* JSON-LD Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "WebSite",
                "@id": `${siteUrl}/#website`,
                url: siteUrl,
                name: "AllChinaBuySpreadsheet",
                description:
                  "The most updated China product sourcing spreadsheet. Discover verified China product suppliers, pricing data, and curated spreadsheets for sneakers, streetwear, electronics, and more.",
                publisher: {
                  "@type": "Organization",
                  "@id": `${siteUrl}/#organization`,
                  name: "AllChinaBuy",
                  url: siteUrl,
                },
              },
              {
                "@type": "Organization",
                "@id": `${siteUrl}/#organization`,
                name: "AllChinaBuy",
                url: siteUrl,
                logo: "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/14bc629c50c04cb08f38590896596985.jpeg",
              },
              {
                "@type": "WebPage",
                "@id": `${siteUrl}/#webpage`,
                url: siteUrl,
                name: "AllChinaBuySpreadsheet – Updated China Product Database 2026",
                isPartOf: { "@id": `${siteUrl}/#website` },
                about: { "@id": `${siteUrl}/#organization` },
                primaryImageOfPage: {
                  "@type": "ImageObject",
                  url: "https://readdy.ai/api/search-image?query=Fresh%20modern%20product%20showcase%20with%20diverse%20fashion%20items%20including%20sneakers%20hoodies%20and%20accessories%20artistically%20arranged%20on%20light%20wooden%20surface%2C%20soft%20warm%20natural%20sunlight%2C%20cream%20white%20walls%20with%20subtle%20texture%2C%20green%20plant%20accents%2C%20clean%20Scandinavian%20aesthetic%2C%20editorial%20product%20photography%2C%20airy%20bright%20atmosphere%2C%20warm%20neutral%20color%20palette%2C%20professional%20lifestyle%20composition&width=1600&height=900&seq=allchinabuy-hero-v2&orientation=landscape",
                },
              },
            ],
          }),
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <ArticleCards />
        <ValueProposition />
        <FeaturesSection />
        <TrustSection />
        <SafetySection />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}